var map = {
	"./cryptocurrencies.svg": 64596,
	"./logo-small.svg": 84932,
	"./logo.svg": 69532,
	"./logo_compact.png": 89084,
	"./offer-active.png": 54183,
	"./offer.png": 31492,
	"./pickup-point-active.png": 69868,
	"./pickup-point.png": 68220,
	"./pkoin.svg": 76284,
	"./self-pickup-icon-active.png": 33496,
	"./self-pickup-icon.png": 70256,
	"./self-pickup.png": 47972,
	"./social.svg": 88916
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50748;